import Mutations from './mutations.js';
import Getters from './getters.js';
import Actions from './actions.js';
import data from '@/assets/data/MurderData.js';
import MurderDeathData from '@/assets/data/MurderDeathData.js';


export default {
    state(){
        return {
            MurderData: data.MurderData,
            MurderDeathData : MurderDeathData,
            topTenKillers:[],
            topTenMethods:[],
            murderDates:[],
            killerSoap:'All Soaps',
            methodSoap:'All Soaps',
            deadlySoap:'All Soaps',
            showMurderDetails:true,
        }
    },
    mutations: Mutations,
    getters: Getters,
    actions: Actions
}